module.exports = __webpack_public_path__ + "static/GPmain6-04b9f9b43401e0a85b2d7dbfaefb7681.png";